const BASE_URL = '/lishui-gov'

import request from '@/common/api/request'

// 白名单日志分页列表
export const examWhiteRecordPage = (params) => request(BASE_URL + '/govEntWhite/examWhiteRecordPage', { params })

